<template><ProductDetailBase route-key="/products/export" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "ExportProductPage", components: { ProductDetailBase } };
</script>
